import React from 'react';

import Button from '@pb/kit-component-button';
import {Input} from '@pb/kit-component-input-v2';

import {
    atPrefix,
    domainInputRow,
    domainInputWrapper,
    errorText,
} from '../domain-manager.module.styl';

type DomainInputRowProps = {
    value: string,
    error: string | null,
    placeholder?: string,
    disabled?: boolean,
    onValueChange: (value: string) => void,
    onSubmit: () => void,
};

export const DomainInputRow: React.FC<DomainInputRowProps> = ({
    value,
    error,
    placeholder = 'yourcompany.com',
    disabled = false,
    onValueChange,
    onSubmit,
}) => {
    return (
        <div>
            <div className={domainInputRow}>
                <div className={domainInputWrapper}>
                    <Input
                        value={value}
                        placeholder={placeholder}
                        disabled={disabled}
                        color={error != null ? 'ERROR' : 'DEFAULT'}
                        startAdornment={<span className={atPrefix}>@</span>}
                        onChange={e => onValueChange(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter' && value.trim().length > 0) {
                                onSubmit();
                            }
                        }}
                    />
                </div>
                <Button
                    variant="Type.PRIMARY"
                    onClick={onSubmit}
                    disabled={disabled || value.trim().length === 0}>
                    Verify
                </Button>
            </div>
            {error != null && <div className={errorText}>{error}</div>}
        </div>
    );
};
